export default "__VITE_ASSET__C96XXSlF__"